module.exports = __webpack_public_path__ + "img/login-v2.9fc517db.svg";